// ENTITY com.ic2.services.dto.LoginResponse generated by ic2 4.0.0-SNAPSHOT at Thu Oct 01 15:16:31 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';
import { UserBundle } from './UserBundle';

export class LoginResponse {

  static readonly __ic2_fqn: string = 'com.ic2.services.dto.LoginResponse';

  token: string | null = '';
  ub: UserBundle | null = null;

  constructor(init?:Partial<LoginResponse>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['com.ic2.services.dto.LoginResponse'] = LoginResponse;

fields['com.ic2.services.dto.LoginResponse']  = {
    token: 'java.lang.String',
    ub: 'com.ic2.entity.UserBundle'
};
